<template>
  <el-container>
    <el-main>
      <el-row type="flex" align="middle" style="height: 100%;">
        <el-col :span="12" :style="{ backgroundImage: `url(${bg})`, backgroundRepeat: 'no-repeat', backgroundSize: 'cover', backgroundPosition: 'center center', height: '100%' }">
          &nbsp;
        </el-col>
        <el-col :span="12">
          <div class="login-wrap">
            <div class="soft-name">
              <div class="logo">
                <div class="logo-img">
                  <el-image :src="logo"></el-image>
                </div>
                <div class="brand">邻当家</div>
              </div>
            </div>
            <div class="login-box">
              <el-form :model="loginData" :rules="rules">
                <el-form-item prop="username">
                  <el-input v-model="loginData.username" placeholder="请输入账号"></el-input>
                </el-form-item>
                <el-form-item prop="password">
                  <el-input v-model="loginData.password" placeholder="请输入密码" type="password"></el-input>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" style="width: 100%;" @click="login">登录</el-button>
                </el-form-item>
              </el-form>
            </div>
          </div>
        </el-col>
      </el-row>
    </el-main>
  </el-container>
</template>

<script>
import request from '@/utils/request'
import bg from '@/assets/bg.jpg'
import logo from '@/assets/logo.png'
export default {
  name: 'Login',
  data () {
    return {
      logo: logo,
      bg: bg,
      loginData: {
        username: 'admin',
        password: 'admin888'
      },
      rules: {
        username: [
          { required: true, message: '请输入用户名', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' }
        ]
      }
    }
  },
  mounted() {
    // this.register()
  },
  methods: {
    login () {
      request.post('login', this.loginData).then(res => {
        localStorage.setItem('admin', res.data.name)
        localStorage.setItem('token', res.data.token)
        this.$router.push('/dashboard')
      }).catch(err => {
        console.log(err)
      })
    },
    register () {
      request.post('register', this.loginData)
    }
  }
}
</script>

<style scoped>
.el-container {
  background-color: #fff;
  height: 100%;
}
.el-main {
  padding: 0;
}
.is-align-stretch {
  align-items: stretch;
}
.soft-name {
  display: flex;
  align-items: center;
  margin-bottom: 40px;
}
.login-wrap {
  padding: 20px;
  max-width: 600px;
  margin: 0 auto;
}
.logo {
  display: flex;
  align-items: center;
}
.logo-img {
  width: 120px;
  margin-right: 20px;
}
.brand {
  font-size: 48px;
  color: #0688d0;
  line-height: 48px;
  font-weight: bold;
}
</style>
